import React, { Component, useState, useEffect, useContext } from 'react'

import ResizeDetector from 'react-resize-detector'
import { withStyles } from '@material-ui/core/styles'

import { NavigationContext } from './NavigationController'
import { useWindowSize } from '../utilities/useWindowSize'

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    direction: 'row'
  },
  mainPane: {
    flexGrow: 1,
    width: '80%'
  },
  sidePane: {
    minWidth: 300,
    width: '20%',
  },
  sidePaneContainer: {
    position: 'fixed',
    //overflow: 'scroll',
    paddingLeft: theme.spacing(2),
  },  
})

const DetailView = ({ theme, classes, children, ...props }) => {

  const { sideContent } = props
  
  const [ windowWidth, windowHeight ] = useWindowSize()

  const navigationContext = useContext(NavigationContext)  

  let sidePaneContainerStyle = {
    position: 'fixed',
    top: navigationContext.contentInset.top + theme.spacing(2) + 'px',
    height: windowHeight - navigationContext.contentInset.top + 'px',
    //width: '100%'
  }  
  
  return (
    <div className={classes.root}>
      <div className={classes.mainPane}>    
        { children }        
      </div>
      
      { sideContent && 
        <div className={classes.sidePane}>        
          <ResizeDetector
            handleWidth
            render={({ width }) => (
              <div className={classes.sidePaneContainer}
                style={{ 
                    width: width, 
                    position: 'absolute',
                    ...sidePaneContainerStyle
                  }}
                >
                { sideContent }
              </div>
            )}
          />
        </div>
      }
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(DetailView)  
